import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import translations from "@/i18n/translations";

const STORAGE_KEY = "st_locale";
const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === "ar" || saved === "en" ? saved : "en";
  });

  const t = useMemo(() => translations[locale] || translations.en, [locale]);
  const dir = t.direction;

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = locale;
      document.documentElement.dir = dir;
    }
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, locale);
    }
  }, [locale, dir]);

  const toggleLocale = useCallback(() => {
    setLocale((l) => (l === "en" ? "ar" : "en"));
  }, []);

  const value = useMemo(() => ({ locale, dir, t, toggleLocale, setLocale }), [locale, dir, t, toggleLocale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
